// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"015e527d","453":"b3c4602d","553":"ef884f9c"}[chunkId] + ".chunk.js";
};